import Text from 'components/Text/Text';
import { useCompareFormData } from 'hooks/useCompareFormData';
import React, { useContext } from 'react';
import { Form } from 'antd';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import classNames from 'classnames';
import { EditTeaserContext, IEditTeaserContext } from '../../../../../../editTeaserState/editTeaserContext';
import style from './BtnBlock.module.scss';

const BtnBlock: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		selectedCustomer,
		selectedRestaurants,
		selectedContentType,
		description,
		schedule,
		totalSchedules,
		selectedTransitionType,
		selectedTransitionDishCategory,
		selectedTransitionDishSubCategory,
		selectedTransitionDishName,
		selectedTransitionGameCategory,
		selectedTransitionGameName,
		selectedControlPoint,
		delayTime,
		launchCount,
		countDown,
		fileId,
		filePath,
		initialFormData,
	} = useContext<IEditTeaserContext>(EditTeaserContext);

	const containerClasses = classNames(style.container, {
		[style.visible]:
			selectedCustomer ||
			description ||
			selectedContentType ||
			selectedTransitionDishCategory ||
			selectedTransitionGameCategory ||
			selectedTransitionDishSubCategory ||
			schedule ||
			countDown ||
			delayTime ||
			launchCount ||
			selectedControlPoint ||
			selectedRestaurants.length ||
			selectedTransitionType ||
			selectedTransitionDishName ||
			selectedTransitionGameName ||
			totalSchedules.length,
	});

	const currentFormData = {
		filePath: fileId || filePath || null,
		selectedCustomer,
		selectedRestaurants,
		selectedContentType,
		description,
		schedule,
		totalSchedules,
		selectedTransitionType,
		selectedTransitionDishCategory,
		selectedTransitionDishSubCategory,
		selectedTransitionDishName,
		selectedTransitionGameCategory,
		selectedTransitionGameName,
		selectedControlPoint,
		delayTime,
		launchCount,
		countDown,
	};

	const isEqualFormData = useCompareFormData(initialFormData, currentFormData);

	const handleCancel = () => {
		changeTypeOfModalWindow('toConfirmFieldsClearing');
	};

	return (
		<Form.Item>
			<div className={containerClasses} data-test="BtnBlock">
				<Button
					className={style.cancelBtn}
					theme="outlined"
					onClick={handleCancel}
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#resetIcon`} />
						</svg>
					}>
					<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
				</Button>
				<Button className={style.saveBtn} theme="primaryBlue" type="submit" disabled={isEqualFormData}>
					<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
				</Button>
			</div>
		</Form.Item>
	);
};

export default BtnBlock;
